import dynamoLogo from '../img/dynamoLogo.png';
import shakhtarLogo from '../img/shakhtarLogo.png';
import oleksandriyaLogo from '../img/oleksandriyaLogo.png';
import kryvbasLogo from '../img/kryvbasLogo.png';
import zoryaLogo from '../img/zoryaLogo.png';
import chornomoretsLogo from '../img/chornomoretsLogo.jpg';
import obolonLogo from '../img/obolonLogo.png';
import kolosLogo from '../img/kolosLogo.png';
import rukhLogo from '../img/rukhLogo.png';
import lnzLogo from '../img/lnzLogo.png';
import karpatyLogo from '../img/karpatyLogo.png';
import ingulecLogo from '../img/ingulecLogo.png';
import vorsklaLogo from '../img/vorsklaLogo.png';
import polissyaLogo from '../img/polissyaLogo.png';
import lberigLogo from '../img/lberigLogo.png';
import veresLogo from '../img/veresLogo.png';
import bukovynaLogo from '../img/bukovynaLogo.png';
import viktoriyaLogo from '../img/viktoriyaLogo.png';
import agrobiznesLogo from '../img/agrobiznesLogo.png';
import epitsenterLogo from '../img/epitsenterLogo.png';
import kreminLogo from '../img/kreminLogo.png';
import chernihivLogo from '../img/chernihivLogo.png';
import hirnykLogo from '../img/hirnykLogo.png';
import yuksaLogo from '../img/yuksaLogo.png';
import poltavaLogo from '../img/poltavaLogo.png';
import kudrivkaLogo from '../img/kudrivkaLogo.png';
import podillyaLogo from '../img/podillyaLogo.png';
import metalist1925Logo from '../img/metalist1925Logo.png';
import metalistLogo from '../img/metalistLogo.png';
import nyvaLogo from '../img/nyvaLogo.png';
import fenixMariupolLogo from '../img/fenixMariupolLogo.png';
import metalurhLogo from '../img/metalurhLogo.png';
import prykarpattiaLogo from '../img/prykarpattiaLogo.png';
import dinazLogo from '../img/dinazLogo.png';
import minaiLogo from '../img/minaiLogo.png';
import probiyLogo from '../img/probiyLogo.jpeg'; 
import realPharmaLogo from '../img/realPharmaLogo.png'; 
import lokomotivLogo from '../img/lokomotivLogo.png'; 
import lisneLogo from '../img/lisneLogo.png'; 
import skalaLogo from '../img/skala1911Logo.jpg'; 
import uzhorodLogo from '../img/uzhorodLogo.png';
import kulykivBilkaLogo from '../img/kulykivBilkaLogo.png';
import nyvaVinnytsiaLogo from '../img/nyvaVinnytsiaLogo.png';
import atletLogo from '../img/atletLogo.png';
import vilkhivtsiLogo from '../img/vilkhivtsiLogo.png';
import rebelLogo from '../img/rebelLogo.png';
import trostyanetsLogo from '../img/trostyanetsLogo.png';
import penuelLogo from '../img/penuelLogo.png';
import bratslavLogo from '../img/bratslavLogo.png';
import dnisterZalishchykyLogo from '../img/dnisterZalishchykyLogo.png';
import avangardLozovaLogo from '../img/avangardLozovaLogo.png';
import carbonCherkasyLogo from '../img/carbonCherkasyLogo.png';

export const ClubInfoMap = {
  'Динамо Київ': {
    logo: dynamoLogo,
    name: 'Динамо Київ',
    founded: '13 травня 1927',
    city: 'Київ, Україна',
    stadium: 'НСК «Олімпійський», «Динамо» ім. В. Лобановського',
    president: 'Ігор Суркіс',
    coach: 'Ігор Костюк',
    league: 'Прем\'єр-ліга',
    website: 'https://fcdynamo.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат України:</strong> Чемпіон (16) — 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2003, 2004, 2007, 2009, 2015, 2016, 2021, 2025<br/>
      <strong>Кубок України:</strong> Володар (13)- 1994, 1996, 1998, 1999, 2000, 2003, 2005, 2006, 2007, 2014, 2015, 2020, 2021, 2026<br/>
      <strong>Суперкубок України:</strong> Володар (10)- 2004, 2006, 2007, 2009, 2011, 2016, 2018, 2019, 2020<br/>
      <strong>Чемпіонат СРСР:</strong> Чемпіон (13) - 1961, 1966, 1967, 1968, 1971, 1974, 1975, 1977, 1980, 1981, 1985, 1986, 1990<br/>
      <strong>Кубок СРСР:</strong> Володар (9) - 1954, 1964, 1966, 1974, 1978, 1982, 1985, 1987, 1990<br/>
      <strong>Суперкубок СРСР:</strong> Володар (3) - 1980, 1985, 1986<br/>
      <strong>Кубок володарів кубків УЄФА:</strong> Володар (2) - 1975, 1986<br/>
      <strong>Суперкубок УЄФА:</strong> Володар (1) - 1975<br/>
    `
  },

  'Шахтар': {
    logo: shakhtarLogo,
    name: 'Шахтар',
    founded: '24 травня 1936',
    city: 'Донецьк, Україна',
    stadium: '«Донбас Арена», «Арена Львів» (Львів)',
    president: 'Рінат Ахметов',
    coach: 'Арда Туран',
    league: 'Прем\'єр-ліга',
    website: 'https://shakhtar.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат України:</strong> Чемпіон (16) — 2001-02, 2004-05, 2005-06, 2007-08, 2009-10, 2010-11, 2011-12, 2012-13, 2013-14, 2016-17, 2017-18, 2018-19, 2019-20, 2022-23, 2023-24, 2025-26<br/>
      <strong>Кубок України:</strong> Володар (14)- 1994-95, 1996-97, 2000-01, 2001-02, 2003-04, 2007-08, 2010-11, 2011-12, 2012-13, 2015-16, 2016-17, 2017-18, 2018-19, 2023-24, 2024-25<br/>
      <strong>Суперкубок України:</strong> Володар (9)- 2005, 2008, 2010, 2012, 2013, 2014, 2015, 2017, 2021<br/>
      <strong>Кубок СРСР:</strong> Володар (4) - 1961, 1962, 1980, 1983<br/>
      <strong>Суперкубок СРСР:</strong> Володар (1) - 1984<br/>
      <strong>Кубок володарів кубків УЄФА:</strong> Володар (2) - 1975, 1986<br/>
      <strong>Ліга Європи:</strong> Володар (1) - 2008–09<br/>
    `
  },

  'Кривбас': {
    logo: kryvbasLogo,
    name: 'Кривбас',
    founded: '1959, 2020',
    city: 'Кривий Ріг, Україна',
    stadium: '«Гірник»',
    president: 'Костянтин Караманіц',
    coach: 'Патрік ван Леувен',
    league: 'Прем\'єр-ліга',
    website: 'https://fckryvbas.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат України:</strong> Бронзовий призер (3) - 1998/1999, 1999/2000, 2023/2024<br/>
    `
  },

  'Зоря': {
    logo: zoryaLogo,
    name: 'Зоря',
    founded: '1923',
    city: 'Луганськ, Україна',
    stadium: '«Авангард» (Луганськ), «Динамо» ім. В. Лобановського (Київ)',
    president: 'Євген Геллер',
    coach: 'Віктор Скрипник',
    league: 'Прем\'єр-ліга',
    website: 'https://fczorya.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат України:</strong> Бронзовий призер (4) - 2016/17, 2019/20, 2020/21, 2022/23<br/>
      <strong>Кубок України:</strong> Фіналіст (2) - 2015/16, 2020/21<br/>
      <strong>Чемпіонат Першої Ліги:</strong> Чемпіон (1) - 2005/06, Бронзовий призер (1) - 2004/05<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Чемпіон (1) - 2002/03, Срібний призер (1) - 1998/99, Бронзовий призер (1) - 1999/00<br/>
    `
  },

  'Оболонь': {
    logo: obolonLogo,
    name: 'Оболонь',
    founded: '2013',
    city: 'Київ, Україна',
    stadium: '«Оболонь-Арена»',
    president: 'Олександр Слободян',
    coach: 'Олександр Антоненко',
    league: 'Прем\'єр-ліга',
    website: 'https://fc.obolon.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Першої Ліги:</strong> Срібний призер (1) - 2022/23, Бронзовий призер (1) - 2015/16<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Срібний призер (1) - 2014/15<br/>
    `
  },

  'Колос': {
    logo: kolosLogo,
    name: 'Колос',
    founded: '2012',
    city: 'Ковалівка, Україна',
    stadium: '«Колос»',
    president: 'Андрій Засуха',
    coach: 'Руслан Костишин',
    league: 'Прем\'єр-ліга',
    website: 'https://koloskovalivka.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Першої Ліги:</strong> Срібний призер (1) - 2018/19<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Чемпіон (1) - 2015/16<br/>
    `
  },

  'ЛНЗ': {
    logo: lnzLogo,
    name: 'ЛНЗ',
    founded: '2006',
    city: 'Черкаси, Україна',
    stadium: '«Черкаси-Арена»',
    president: 'Віктор Кравченко',
    coach: 'Віталій Пономарьов ',
    league: 'Прем\'єр-ліга',
    website: 'https://fc-lnz.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
    <strong>Чемпіонат України:</strong> Срібний призер (1) - 2025/26<br/>
    <strong>Чемпіонат Першої Ліги:</strong> Бронзовий призер (1) -  2022/23<br/>
    `
  },

  'Карпати': {
    logo: karpatyLogo,
    name: 'Карпати',
    founded: '2020',
    city: 'Львів, Україна',
    stadium: '«Україна»',
    president: 'Степан Юрчишин',
    coach: 'Франсіско Фернандес',
    league: 'Прем\'єр-ліга',
    website: 'https://fckarpaty.org.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Першої Ліги:</strong> Срібний призер (1) -  2023/24<br/>
    `
  },

  'Полісся': {
    logo: polissyaLogo,
    name: 'Полісся',
    founded: '1959, 2016',
    city: 'Житомир, Україна',
    stadium: 'Центральний',
    president: 'Геннадій Буткевич',
    coach: 'Руслан Ротань',
    league: 'Прем\'єр-ліга',
    website: 'https://polissyafc.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат України:</strong> Бронзовий призер (1) - 2025/26<br/>
      <strong>Чемпіонат Першої Ліги:</strong> Чемпіон (1) - 2022/23<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Чемпіон (1) - 2000-01, Срібний призер  (2) - 1992/93, 2019/20<br/>
    `
  },

  'Верес': {
    logo: veresLogo,
    name: 'Верес',
    founded: '1957, 2015',
    city: 'Рівне, Україна',
    stadium: '«Авангард», Рівне',
    president: 'Іван Надєїн',
    coach: 'Олег Шандрук',
    league: 'Прем\'єр-ліга',
    website: 'https://nkveres.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Першої Ліги:</strong> Чемпіон (2) - 1992, 2020/21, Бронзовий призер (1) - 2016/17<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Срібний призер  (1) - 2015/16<br/>
    `
  },

  'Епіцентр': {
    logo: epitsenterLogo,
    name: 'Епіцентр',
    founded: '2019',
    city: "Кам'янець-Подільський, Україна",
    stadium: 'імені Г. Тонкочеєва',
    president: 'Іван Черноног',
    coach: 'Сергій Нагорняк',
    league: 'Прем\'єр-ліга',
    website: 'https://fcepicentr.com.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Першої Ліги:</strong> Чемпіон (1) - 2024/25<br/>
    `
  },

    'ФК Харків': {
    logo: metalist1925Logo,
    name: 'ФК Харків',
    founded: '17 серпня 2016 року',
    city: "Харків, Україна",
    stadium: '«Металіст»',
    president: 'Володимир Носов',
    coach: 'Младен Бартулович',
    league: 'Перша ліга',
    website: 'https://metalist1925.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Першої Ліги:</strong> Бронзовий призер (1) - 2020/21<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Бронзовий призер (1) - 2017/18<br/>
    `
  },

  'Кудрівка': {
    logo: kudrivkaLogo,
    name: 'Кудрівка',
    founded: '1982, 2006',
    city: "Кудрівка, Україна",
    stadium: '«Кудрівка-Арена»',
    president: 'Роман Солодаренко',
    coach: 'Олександр Протченко',
    league: 'Перша ліга',
    website: 'https://kudrivka.com.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>-</strong> 
    `
  },

  'Лівий Берег': {
    logo: lberigLogo,
    name: 'Лівий Берег',
    founded: '2017',
    city: 'Київ, Україна',
    stadium: 'Арена «Лівий берег»',
    president: 'Микола Лавренко',
    coach: 'Олександр Рябоконь',
    league: 'Прем\'єр-ліга',
    website: 'https://fclb.com.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Першої Ліги:</strong> Бронзовий призер (2) - 2025/26<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Срібний призер  (1) - 2021/22<br/>
    `
  },

  'Чорноморець': {
    logo: chornomoretsLogo,
    name: 'Чорноморець',
    founded: '1936',
    city: 'Одеса, Україна',
    stadium: '«Чорноморець»',
    president: 'Леонід Клімов',
    coach: 'Роман Григорчук',
    league: 'Прем\'єр-ліга',
    website: 'https://chornomorets.ua/',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат України:</strong> Срібний призер (2) - 1994/1995, 1995/1996, Бронзовий призер (3) - 1992/1993, 1993/1994, 2005/2006<br/>
      <strong>Кубок України:</strong> Володар (2) - 1992, 1993/1994, Фіналіст (1) - 2012/2013<br/>
      <strong>Чемпіонат Першої Ліги:</strong> Срібний призер (5) - 1998/1999, 2001/2002, 2010/2011, 2020/2021, 2025/26<br/>
      <strong>Кубок Інтертото:</strong> Фіналіст (1) - 2007<br/>
    `
  },

   'Буковина': {
    logo: bukovynaLogo,
    name: 'Буковина',
    founded: '22 червня 1958',
    city: 'Чернівці, Україна',
    stadium: '«Буковина»',
    president: 'Андрій Сафроняк',
    coach: 'Сергій Шищенко',
    league: 'Перша ліга',
    website: 'https://bukfc.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Першої Ліги:</strong> Чемпіон (1) - 2025/26<br/>
      <strong>Чемпіонат Першої Ліги:</strong> Срібний призер (1) - 1996<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Чемпіон  (2) - 2000, 2010<br/>
    `
  },

  /*-----ПЕРША ЛІГА-----*/

   'Олександрія': {
    logo: oleksandriyaLogo,
    name: 'Олександрія',
    founded: '1948',
    city: 'Олександрія, Україна',
    stadium: 'КСК «Ніка»',
    president: 'Сергій Кузьменко',
    coach: 'Володимир Шаран',
    league: 'Прем\'єр-ліга',
    website: 'https://fco.com.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат України:</strong> Срібний призер (1) - 2024/25, Бронзовий призер (1) - 2018/19<br/>
      <strong>Чемпіонат Першої Ліги:</strong> Чемпіон (2) - 2010/11, 2014/15, Срібний призер (1) - 2013/14, Бронзовий призер (4) - 1993/94, 2000/01, 2008/09, 2012/13<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Срібний призер (1) - 2005/06, Бронзовий призер (1) - 2004/05<br/>
    `
  },

  'Полтава': {
    logo: poltavaLogo,
    name: 'Полтава',
    founded: '2011',
    city: "Полтава, Україна",
    stadium: '«Молодіжний»',
    president: 'Сергій Іващенко',
    coach: 'Павло Матвійченко',
    league: 'Перша ліга',
    website: 'https://scpoltava.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
     <strong>-</strong> 
    `
  },

   'Інгулець': {
    logo: ingulecLogo,
    name: 'Інгулець',
    founded: '2013',
    city: 'Петрове, Україна',
    stadium: '«Інгулець»',
    president: 'Олександр Поворознюк',
    coach: 'Василь Кобін',
    league: 'Прем\'єр-ліга',
    website: 'https://inhulets.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Кубок України:</strong> Фіналіст (1) - 2018/19<br/>
      <strong>Чемпіонат Першої Ліги:</strong> Чемпіон (1) - 2023/24, Бронзовий призер (1) -  2019/20<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Бронзовий призер  (1) - 2015/16<br/>
    `
  },

  'Вікторія': {
    logo: viktoriyaLogo,
    name: 'Вікторія',
    founded: '2015',
    city: 'Суми, Україна',
    stadium: '«Ювілейний»',
    president: 'Сергій Бондаренко',
    coach: '',
    league: 'Перша ліга',
    website: '',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>-</strong> 
    `
  },

  'Агробізнес': {
    logo: agrobiznesLogo,
    name: 'Агробізнес',
    founded: 'грудень 2015',
    city: 'Волочиськ, Україна',
    stadium: '«Юність»',
    president: 'Людмила Собуцька',
    coach: 'Олександр Чижевський',
    league: 'Перша ліга',
    website: 'https://fcab.com.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Другої Ліги:</strong> Чемпіон  (1) - 2017/18<br/>
    `
  },

  'ЮКСА': {
    logo: yuksaLogo,
    name: 'ЮКСА',
    founded: '2015',
    city: "Тарасівка, Україна",
    stadium: 'НТК імені Віктора Баннікова',
    president: 'Сергій Леснік',
    coach: 'Андерсон Мендес Рібейро',
    league: 'Перша ліга',
    website: 'https://ucsa.com.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>-</strong> 
    `
  },

  'Металіст': {
    logo: metalistLogo,
    name: 'Металіст',
    founded: '10 жовтня 2019',
    city: "Харків, Україна",
    stadium: '«Металіст»',
    president: 'Олександр Ярославський',
    coach: 'Андрій Аніщенко',
    league: 'Перша ліга',
    website: 'https://fcmetalist.com.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Першої Ліги:</strong> Чемпіони (1) - 2021/22<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Чемпіони (1) - 2020/21<br/>
    `
  },

  'Нива': {
    logo: nyvaLogo,
    name: 'Нива',
    founded: '1978',
    city: "Тернопіль, Україна",
    stadium: '	Тернопільський міський стадіон імені Романа Шухевича',
    president: 'Наконечний Дмитро',
    coach: '',
    league: 'Перша ліга',
    website: 'https://fcnyva.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Другої Ліги:</strong> Чемпіони (2) - 2008/09, 2019/20, Срібний призер (1) - 2007/08, Бронзовий призер (1) - 2012/13<br/>
    `
  },

  'Фенікс-Маріуполь': {
    logo: fenixMariupolLogo,
    name: 'Фенікс-Маріуполь',
    founded: '2007',
    city: "Маріуполь, Україна",
    stadium: '«Західний»',
    president: 'Юрій Павлишин',
    coach: 'Максим Фещук',
    league: 'Перша ліга',
    website: '',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>-</strong> 
    `
  },

  'Прикарпаття': {
    logo: prykarpattiaLogo,
    name: 'Прикарпаття',
    founded: '2016',
    city: "Івано-Франківськ, Україна",
    stadium: '«Рух»',
    president: 'Василь Попович',
    coach: 'Олег Рипан',
    league: 'Перша ліга',
    website: 'https://fc.if.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Другої Ліги:</strong> Срібний призер (1) - 2017/18<br/>
    `
  },

  'Пробій': {
    logo: probiyLogo,
    name: 'Пробій',
    founded: '1924',
    city: "Городенка, Україна",
    stadium: '«Пробій-Арена»',
    president: 'Віталій Шевага',
    coach: 'Володимир Ковалюк',
    league: 'Друга ліга',
    website: 'https://nkprobiy.if.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Другої Ліги:</strong> Чемпіон (1) - 2024/25<br/>
    `
  },

  'Чернігів': {
    logo: chernihivLogo ,
    name: 'Чернігів',
    founded: '	18 червня 2003',
    city: "Чернігів, Україна",
    stadium: '«Чернігів-Арена»',
    president: 'Юрій Синиця',
    coach: 'Василь Баранов',
    league: 'Друга ліга',
    website: 'https://chernigiv.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
       <strong>Кубок України:</strong> Фіналіст - 2025/26<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Бронзовий призер (1) - 2024/25<br/>
    `
  },

  'Куликів-Білка': {
  logo: kulykivBilkaLogo,
  name: 'Куликів-Білка',
  founded: '2008',
  city: 'Куликів, Україна',
  stadium: 'Арена Куликів',
  president: 'Мирон Остапчак',
  coach: 'Богдан Костик',
  league: 'Перша ліга',
  website: 'https://fckulykiv-bilka.com.ua/',
  achievements: `
    <strong>Досягнення:</strong><br/>
    <strong>Чемпіонат Другої Ліги:</strong> Чемпіон (1) - 2025/26<br/>
  `
},

'Локомотив': {
  logo: lokomotivLogo,
  name: 'Локомотив',
  founded: '1919', 
  city: "Київ, Україна",
  stadium: '«НТК імені Віктора Баннікова»',
  president: 'Олександр Єгоров',
  coach: 'Сергій Карпенко',
  league: 'Друга ліга',
  website: '', 
  achievements: `
    <strong>Досягнення:</strong><br/> 
     <strong>-</strong> 
  `
},

  /*-----ДРУГА ЛІГА-----*/

  'Рух': {
    logo: rukhLogo,
    name: 'Рух',
    founded: '2003',
    city: 'Львів, Україна',
    stadium: '«Арена Львів»',
    president: 'Юлія Думанська',
    coach: '',
    league: 'Прем\'єр-ліга',
    website: 'https://fcrukh.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Першої Ліги:</strong> Срібний призер (1) -  2019–2020<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Срібний призер  (1) - 2016–2017<br/>
    `
  },

  'Металург': {
    logo: metalurhLogo,
    name: 'Металург',
    founded: '2017',
    city: "Запоріжжя, Україна",
    stadium: '«Славутич-Арена»',
    president: 'Максим Лупашко',
    coach: 'Сергій Ковалець',
    league: 'Перша ліга',
    website: '',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Другої Ліги:</strong> Бронзовий призер (1) - 2018/19<br/>
    `
  },

   'Поділля': {
    logo: podillyaLogo,
    name: 'Поділля',
    founded: '1960',
    city: "Хмельницький, Україна",
    stadium: '«Поділля»',
    president: 'Євген Бейдерман',
    coach: 'Сергій Ковалець',
    league: 'Перша ліга',
    website: 'https://fcpodillya.com.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>-</strong> 
    `
  },

   'Діназ': {
    logo: dinazLogo,
    name: 'Діназ',
    founded: '1999',
    city: "Вишгород, Україна",
    stadium: '«Діназ» ',
    president: 'Роман Капаністий',
    coach: 'Олександр Головко',
    league: 'Перша ліга',
    website: '',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Другої Ліги:</strong> Бронзовий призер (1) - 2020/21<br/>
    `
  },

'Скала 1911': {
  logo: skalaLogo,
  name: 'Скала 1911',
  founded: '1911',
  city: 'Стрий, Україна',
  stadium: 'Стадіон "Сокіл"',
  president: 'Олег Канівець', // можна додати реальні дані
  coach: 'Степан Матвіїв',     // також можна додати тренера
  league: 'Друга ліга',
  website: 'http://fcskala.com', // або офіційний ресурс
  achievements: `
    <strong>Досягнення:</strong><br/>
    <strong>-</strong>
  `
},



'Нива Вінниця': {
  logo: nyvaVinnytsiaLogo,
  name: 'Нива Вінниця',
  founded: '1958, 2016',
  city: 'Вінниця, Україна',
  stadium: 'НТБ Нива',
  president: 'Артур Загорулько',
  coach: 'Юрій Ярошенко',
  league: 'Друга ліга',
  website: '',
  achievements: `
    <strong>Досягнення:</strong><br/>
    <strong>Чемпіонат Першої Ліги:</strong> Чемпіони (1) - 1992/93<br/>
  `
},

'Атлет': {
  logo: atletLogo,
  name: 'Атлет',
  founded: '2006',
  city: 'Київ, Україна',
  stadium: 'Атлет',
  president: 'Олексій Лихочас',
  coach: 'Дмитро Мурашенко',
  league: 'Друга ліга',
  website: '',
  achievements: `
    <strong>Досягнення:</strong><br/>
  `
},

'Вільхівці': {
  logo: vilkhivtsiLogo,
  name: 'Вільхівці',
  founded: '1969',
  city: 'Вільхівці, Україна',
  stadium: 'Вільхівці-Арена-Парк',
  president: 'Михайло Цірик',
  coach: 'Олексій Зорін',
  league: 'Друга ліга',
  website: '',
  achievements: `
    <strong>Досягнення:</strong><br/>
  `
},

'Ребел': {
  logo: rebelLogo,
  name: 'Ребел',
  founded: '2024',
  city: 'Київ, Україна',
  stadium: 'НТК ім. Віктора Баннікова',
  president: '-',
  coach: '-',
  league: 'Друга ліга',
  website: '',
  achievements: `
    <strong>Досягнення:</strong><br/>
  `
},

'Тростянець': {
  logo: trostyanetsLogo,
  name: 'Тростянець',
  founded: '2015',
  city: 'Тростянець, Україна',
  stadium: 'Стадіон ім. В. Куца',
  president: 'Богдан Єсип',
  coach: 'Юрій Бакалов',
  league: 'Друга ліга',
  website: 'https://www.fctrostyanets.com/',
  achievements: `
    <strong>Досягнення:</strong><br/>
  `
},

'Пенуел': {
  logo: penuelLogo,
  name: 'Пенуел',
  founded: '2005',
  city: 'Кривий Ріг, Україна',
  stadium: 'ім. Олександра Поворознюка (с. Володимирівка)',
  president: 'Юлій Морозов',
  coach: '-',
  league: 'Друга ліга',
  website: 'Ігор Солоденко',
  achievements: `
    <strong>Досягнення:</strong><br/>
  `
},

'Брацлав': {
  logo: bratslavLogo,
  name: 'Брацлав',
  founded: '2025',
  city: 'Вінниця, Україна',
  stadium: 'НТБ Нива',
  president: 'Юрій Максименко',
  coach: 'Василь Блінніков',
  league: 'Друга ліга',
  website: '',
  achievements: `
    <strong>Досягнення:</strong><br/>
  `,
},

'Дністер': {
  logo: dnisterZalishchykyLogo,
  name: 'Дністер',
  founded: '1913',
  city: 'Заліщики, Тернопільська область, Україна',
  stadium: 'Дністер',
  president: 'Юрій Куц',
  coach: 'Валерій Іващенко',
  league: 'Друга ліга',
  website: '',
  achievements: `
    <strong>Досягнення:</strong><br/>
  `,
},

'Авангард': {
  logo: avangardLozovaLogo,
  name: 'Авангард',
  founded: '2021',
  city: 'Лозова, Харківська область, Україна',
  stadium: 'Молодіжний',
  president: 'Василь Левченко',
  coach: 'Ігор Рахаєв',
  league: 'Друга ліга',
  website: '',
  achievements: `
    <strong>Досягнення:</strong><br/>    
  `,
},

'Карбон': {
  logo: carbonCherkasyLogo,
  name: 'Карбон',
  founded: '2016',
  city: 'Черкаси, Україна',
  stadium: ' «Черкаси Арена»',
  president: 'Нарек Казарян',
  coach: 'Ігор Столовицький',
  league: 'Друга ліга',
  website: '',
  achievements: `
    <strong>Досягнення:</strong><br/>   
  `,
},

  /*-----Команди на паузі-----*/

  'Кремінь': {
    logo: kreminLogo ,
    name: 'Кремінь',
    founded: '1959, 1986, 2003',
    city: "Кременчук, Україна",
    stadium: '«Кремінь-Арена»',
    president: 'Сергій Ковнір',
    coach: 'Ігор Климовський',
    league: 'Перша ліга',
    website: 'https://fckremen.com.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Другої Ліги:</strong> Чемпіон  (1) - 2018/19, Бронзовий призер (3) - 2009/10, 2014/15, 2016/17<br/>
    `
  },

  'Минай': {
    logo: minaiLogo,
    name: 'Минай',
    founded: '2015',
    city: "Минай, Україна",
    stadium: '«Минай-Арена»',
    president: 'Валерій Пересоляк',
    coach: '-',
    league: 'Перша ліга',
    website: 'https://fcminaj.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Першої Ліги:</strong> Чемпіони (1) - 2019/20<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Срібний призер (1) - 2018/19<br/>
    `
  },

  'Ворскла': {
    logo: vorsklaLogo,
    name: 'Ворскла',
    founded: '5 січня 1955',
    city: 'Полтава, Україна',
    stadium: '«Ворскла» ім. Олексія Бутовського',
    president: 'Костянтин Жеваго',
    coach: 'Олександр Бабич',
    league: 'Прем\'єр-ліга',
    website: 'https://vorskla.com.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат України:</strong> Бронзовий призер (2) - 1996/97, 2017/18<br/>
      <strong>Кубок України:</strong> Володар (1) - 2008/09, Фіналіст (2) - 2019/20, 2023/24<br/>
      <strong>Суперкубок України:</strong> Фіналіст (1) - 2009<br/>
    `
  },

  'Лісне': {
  logo: lisneLogo,
  name: 'Лісне',
  founded: '2023',              
  city: 'село Лісне, Київська область',           
  stadium: 'Бузова-Арена',
  president: 'Віктор Зеленський',
  coach: 'Олександр Рябоконь',
  league: 'Друга ліга',
  website: '',
  achievements: `
    <strong>Досягнення:</strong><br/>
    <strong>-</strong>
  `
},

'ФК Ужгород': {
  logo: uzhorodLogo,
  name: 'ФК Ужгород',
  founded: '2015',
  city: 'Ужгород, Україна',
  stadium: 'Стадіон "Авангард"',
  president: 'Рудольф Балажинець', // можна додати реальні дані
  coach: 'Яромир Лобода',
  league: 'Друга ліга',
  website: 'https://fcuzhhorod.com.ua/', 
  achievements: `
    <strong>Досягнення:</strong><br/>
     <strong>-</strong>
  `
},

'Реал Фарма': {
    logo: realPharmaLogo,
    name: 'Реал Фарма',
    founded: '2000',
    city: "Одеса, Україна",
    stadium: '«Іван»',
    president: 'Микола Лиховидов',
    coach: 'Валентин Полтавець',
    league: 'Друга ліга',
    website: 'https://real-farma.com.ua',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>-</strong> 
    `
  },

  'Гірник-Спорт': {
    logo: hirnykLogo,
    name: 'Гірник-Спорт',
    founded: '1989',
    city: "Горішні Плавні, Україна",
    stadium: '«Юність»',
    president: 'Петро Каплун',
    coach: 'Павло Ребенок',
    league: 'Друга ліга',
    website: 'https://gornyak-sport.com',
    achievements: `
    <strong> Досягнення:</strong><br/> 
      <strong>Чемпіонат Першої Ліги:</strong> Бронзовий призер (1) - 2014/15<br/>
      <strong>Чемпіонат Другої Ліги:</strong> Чемпіон  (1) - 2013/14<br/>
    `
  },
};
